// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RLqk","colMin":"styles_colMin__3uOy0"};